<template>
  <el-row class="text-align-left">
    <el-col :span="24" class="banner">
      <div class="banner-image">
        <img src="../assets/OOCL_logo.svg" class="oocl-logo">
        <div class="assessment-intro">
          <div class="assessment-title">{{welcomeTitle}}</div>
          <div class="assessment-wording" v-html="answerPageContent"></div>
        </div>
      </div>
    </el-col>
    <el-col :xl="3" :lg="4" :md="5" :sm="6" style="height:10px"></el-col>
    <el-col :xl="21" :lg="20" :md="19" :sm="18">
      <div class="assessment-body">
        <div class="assessment-body-title">{{unsubscribeTitleAll}}</div>
        <div v-html="unsubscribeTextAll"></div>
        <el-button @click="showUnsubscribeWarning" v-if="isShowBtn">{{unsubscribeButtonAll}}</el-button>
      </div>
    </el-col>
    <el-col id="cookie-policy" :span="24" class="cookie-policy" v-if="showCookiePolicy">
      <div style="width: 100%;text-align: right;padding-right: 20px;margin-top: -22px;" v-if="showBackground">
      <span class="csck-modal-glide" @click="CloseCookieModal" data-dismiss="modal">
       <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
         <g id="ICON" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
           <rect id="Rectangle-2-Copy" fill="#28469C" x="2" y="17" width="20" height="2"></rect>
           <polyline id="Path-3" stroke="#28469C" stroke-width="2" points="5 5 12 12 19 5"></polyline>
         </g>
       </svg>
       </span>
      </div>
      <el-col :xl="2" :lg="2" :md="1" :sm="1" style="height:1px"></el-col>
      <el-col :xl="16" :lg="15" :md="22" :sm="22" class="container padding">
        <div class="cookie-msg"><u>Cookies Notice</u><br><br>
          <div class="col-lg-9 col-md-8 col-sm-12 col-xs-12 cookie-msg">
            We use cookies as a fundamental part of our interaction with our users’ browsers.<br/><br/>
            We rely on your consent for placing on your browser cookies which may collect personal data about you. You can provide your consent by clicking “Accept”. You are free at any time to block or delete cookies through your browser.
          </div></div>
      </el-col>
      <el-col :xl="4" :lg="5" :md="22" :sm="22" class="text-center">
        <el-button type="danger" @click="acceptCookiePolicy">Accept</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
        <el-button type="default" @click="goKnowMore">Read More</el-button>
      </el-col>
      <el-col :xl="2" :lg="2" :md="1" :sm="1" style="height:10px"></el-col>
    </el-col>
    <div id="full-background" v-if="showBackground"></div>
    <Footer v-on:init="init"></Footer>
  </el-row>
</template>

<script>
import Footer from '@/components/Footer.vue';
import { modifiedStakeholderUnsubscribe, checkStakeholderInfo } from '@/services/stakeholder.service';
import Constant from '@/common/Constant';
import CookiesHelper from '@/utils/cookiesHelper'

export default {
  components: {
    Footer
  },
  data () {
    return {
      stakeholderId: '',
      userName: '',
      answererDto: {
        userType: '',
        answerAssessmentId: '',
        keyCode: ''
      },
      welcomeTitle: '',
      cancelButtonAll: '',
      unsubscribeButtonAll: '',
      unsubscribeTextAll: '',
      unsubscribeTitleAll: '',
      answerPageContent: '',
      showBackground: false,
      showCookiePolicy: false,
      isShowBtn: true
    };
  },
  methods: {
    cancelUnsubscribe () {
      window.location.href = 'about:blank';
      window.close();
    },
    showUnsubscribeWarning () {
      if (this.showCookiePolicy === true) {
        this.moveCookiePolicy();
      } else {
        this.$confirm(`Are you sure to unsubscribe? /  您确定取消订阅吗？`, 'Unsubscribe / 取消订阅', {
          confirmButtonText: 'Yes / 是',
          cancelButtonText: 'No / 否',
          confirmButtonClass: 'el-button--danger'
        }).then(() => {
          this.unsubscribe();
        }).catch(cancel => {
          console.log('Cancel.');
        });
      }
    },
    unsubscribe () {
      modifiedStakeholderUnsubscribe(this.stakeholderId).then(val => {
        let stakeholderMessageVo = val.data;
        if (stakeholderMessageVo.succeed) {
          this.unsubscribeTextAll = '<p>Unsubscribed.</p><p>已取消订阅。</p>';
          this.isShowBtn = false;
        } else {
          this.$alert('Unsubscribed failed, please contact the administrator soon. / 取消订阅失败，请尽快联系管理员。', {
            confirmButtonText: 'OK / 确定',
            confirmButtonClass: 'el-button--danger'
          });
        }
      });
    },
    handleUrl () {
      let url = document.location.toString();
      let arrUrl = url.split('//')[1];
      let params = arrUrl.split('/');
      this.answererDto.userType = params[2];
      this.answererDto.answerAssessmentId = params[3];// 125edeba653258000165325be563000b
      this.answererDto.keyCode = params[4];// e9c4229c-7ace-44dd-909a-bb3d21d8cc08
    },
    async checkUserInfo () {
      checkStakeholderInfo(this.answererDto).then(val => {
        let stakeholderMessageVo = val.data;
        this.userName = stakeholderMessageVo.name;
        this.stakeholderId = stakeholderMessageVo.id;
        this.isShowBtn = true;
        this.init();
      });
    },
    init () {
      this.cancelButtonAll = this.$store.state.dictionary[4].BUTTON_CANCEL;
      this.unsubscribeTitleAll = this.$store.state.dictionary[4].BUTTON_UNSUBSCRIBE;
      this.unsubscribeButtonAll = this.$store.state.dictionary[4].BUTTON_UNSUBSCRIBE;
      this.welcomeTitle = this.$store.state.dictionary[1].WELCOME_TITLE_STAKEHOLDER;
      this.unsubscribeTextAll = this.replaceAnswererText(Constant.STAKEHOLDER_PAGES_TEXT, this.$store.state.dictionary[4].UNSUBSCRIBE_TEXT, this.userName);
      this.answerPageContent = this.replaceAnswererText(Constant.STAKEHOLDER_PAGES_TEXT, this.$store.state.dictionary[1].WELCOME_CONTENT_STAKEHOLDER, this.userName);
    },
    replaceAnswererText (target, info, answererName) {
      info = info.replace(new RegExp(target, 'g'), answererName);
      return info;
    },
    moveCookiePolicy () {
      this.showBackground = true;
      let a = document.getElementById('cookie-policy');
      a.style.top = '50%';
    },
    CloseCookieModal () {
      this.showBackground = false;
      let a = document.getElementById('cookie-policy');
      a.style.removeProperty('top');
    },
    goKnowMore () {
      window.open(Constant.COOKIE_POLICY);
    },
    acceptCookiePolicy () {
      let Days = 30;
      let exp = new Date();
      exp.setTime(exp.getTime() + Days * 24 * 3600 * 1000);
      document.cookie = 'AcceptCookie' + '=' + 'yes' + '; expires=' + exp.toGMTString() + '; path=/';
      this.showCookiePolicy = false;
      this.showBackground = false;
    },
    readCookie () {
      let isAccepted = CookiesHelper.get('AcceptCookie');
      this.showCookiePolicy = !(isAccepted !== null && isAccepted === 'yes');
    }
  },
  mounted () {
    document.title = 'OOCL Stakeholder Engagement Survey';
    this.readCookie();
    this.handleUrl();
    this.checkUserInfo();
  }
};
</script>

<style scoped>
  .text-align-left {
    text-align: left;
    height: 100%;
  }
  .banner{
    position: fixed;
    background-color: #fff;
    z-index: 9;
    height: 230px;
  }
  .banner-image {
    background-image: url("../assets/assessment_banner.jpg");
    height: 185px;
    background-repeat: no-repeat;
    background-position: center;
  }

  .oocl-logo {
    height: 50px;
    padding-left: 48px;
    padding-top: 50px;
  }

  .assessment-intro {
    display: inline-block;
    color: #fff;
    margin: 0 0 0 88px;
    position: relative;
    top: 35px;
  }

  .assessment-title {
    font-size: 42px;
    font-weight: bold;
  }

  .assessment-wording {
    font-size: 16px;
    margin-top: 15px;
    width: 600px;
  }

  .assessment-body{
    margin: 50px 40px 0 40px;
    position: relative;
    top: 185px;
  }

  .assessment-body-title{
    color: #2d2d2d;
    font-weight: bold;
    font-size: 28px;
    margin-bottom: 35px;
  }
  .assessment-body .el-button{
    width: 230px;
    height: 44px;
    margin-right: 30px;
    margin-top: 20px;
    font-size: 16px;
  }

  /* RWD Support */
  @media screen and (max-width: 1200px){
    .assessment-title {
      font-size: 36px;
    }

    .assessment-steps{
      margin: 55px 40px;
    }
  }

  /*cookie */
  .cookie-policy {
    position: fixed;
    width: 100%;
    bottom: 0;
    z-index: 19;
    background: #f3ffff;
    padding: 32px 0;
    color: #226c94;
    font-size: 16px;
    -webkit-box-shadow: 0 -2px 8px rgba(0,0,0,.25);
    -moz-box-shadow: 0 -2px 8px rgba(0,0,0,.25);
    box-shadow: 0 -2px 8px rgba(0,0,0,.25);
    height: 250px;
  }

  .cookie-msg{
    padding-bottom: 20px;
  }

  .cookie-policy .container {
    height: auto!important;
    min-height: 100px;
  }

  .text-center{
    text-align: center;
    padding-left: 20px;
  }
  @media screen and (max-height: 900px){
    .assessment-steps{
      height: 400px;
    }
  }

  @media screen and (max-height: 800px){
    .assessment-steps{
      height: 320px;
    }
  }

  /*rewrite element ui style */
  >>>.el-button{
    border-color: #D63246;
    color: #D63246;
  }

  >>>.el-button:hover{
    border-color: #D63246;
    background-color: #f4dbdb;
    color: #D63246;
  }

  >>>.el-button:focus{
    border-color: #D63246;
    background-color: #f4dbdb;
    color: #D63246;
  }

  >>>.el-button--danger{
    background-color: #D63246;
    border-color: #D63246;
    color: #fff;
  }

  >>>.el-button--danger:hover{
    background-color: #bf2134;
    border-color: #bf2134;
    color: #fff;
  }

  >>>.el-button--danger:focus{
    background-color: #bf2134;
    border-color: #bf2134;
    color: #fff;
  }

  #full-background {
    width: 100%;
    height: 100%;
    background-color: gray;
    left: 0;
    opacity: 0.5;
    position: absolute;
    top: 0;
    z-index: 18;
    filter: alpha(opacity=50);
    -moz-opacity: 0.5;
    -khtml-opacity: 0.5;
  }
  html, body {
    margin: 0;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/StakeholderUnsubscribe.vue